export default __webpack_public_path__ + "media/cloudone-signup-bg.56f57adc.png";